export enum FsaEvents {
  Note = 'note',
  Appointment = 'appointment',
  Perio = 'perio',
  Treatment = 'treatment',
  General = 'general',
}
